import { render, staticRenderFns } from "./brandLogoPage.vue?vue&type=template&id=1a0e4622&"
import script from "./brandLogoPage.vue?vue&type=script&lang=js&"
export * from "./brandLogoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports